import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { PanelComponent }            from '@libs/front/components/panel/panel.component';
import { MetabaseDashboardComponent } from 'src/app/shared/components/metabase-dashboard/metabase-dashboard.component';
import { UtilisateurService }         from 'src/app/services/utilisateur.service';
import { DeviceService }              from 'src/app/services/device.service';

@Component({
  selector:    'app-site-dashboard',
  standalone:  true,
  imports:     [CommonModule, PanelComponent, MetabaseDashboardComponent],
  templateUrl: './site-dashboard.component.html',
  styleUrls:   ['./site-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteDashboardComponent implements OnChanges {

  @Input() siteId: number | null = null;

  readonly utilService = inject(UtilisateurService);
  readonly device              = inject(DeviceService);

  /** Contrôle le montage de app-metabase-dashboard pour forcer le rechargement de l'iframe */
  loadMetabase = signal(false);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['siteId'] && this.siteId) {
      // Sync currentSite dans UtilisateurService pour que Metabase ait le bon siteId
      const site = this.utilService.listeSites.find(s => s.siteId === this.siteId);
      if (site) {
        this.utilService.setCurrentSite(site);
      }

      // Force le rechargement de l'iframe
      this.loadMetabase.set(false);
      setTimeout(() => this.loadMetabase.set(true), 100);
    }
  }
}
